<!-- 资金管理-授信記錄 -->
<template>
  <div>
    <page :url="url" :form="form" @reset="reset">
      <template slot="tableSearch">
        <el-form-item :label="$t('text.merchantName')">
          <el-select
              v-model="form.appId"
              filterable
              :placeholder="$t('message.chooseOne')"
              popper-class="eloption"
          >
            <el-option :label="$t('option.all')" value=""></el-option>
            <el-option
                v-for="merchant in merchantList"
                :label="merchant.value + '-' + merchant.name"
                :key="merchant.value"
                :value="merchant.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('text.creditStatus')">
          <el-select v-model="form.status" :placeholder="$t('text.status')">
            <el-option :label="$t('option.all')" value=""></el-option>
            <el-option :label="$t('creditStatus.00')" value="00"></el-option>
            <el-option :label="$t('creditStatus.01')" value="01"></el-option>
            <el-option :label="$t('creditStatus.02')" value="02"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('text.settlementStatus')">
          <el-select v-model="form.settlementStatus"
                     :placeholder="$t('text.settlementStatus')">
            <el-option :label="$t('option.all')"
                       value=""/>
            <el-option :label="$t('settlementStatus.00')"
                       value="00"/>
            <el-option :label="$t('settlementStatus.01')"
                       value="01"/>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('text.orderNumber')">
          <el-input v-model="form.orderId" :placeholder="$t('text.orderNumber')" maxlength="50"></el-input>
        </el-form-item>

        <el-form-item :label="$t('text.date')">
          <el-date-picker
              v-model="timeDate"
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyyMMdd"
              :range-separator="$t('text.to')"
              :start-placeholder="$t('text.startDate')"
              :end-placeholder="$t('text.endDate')"
              @change="timeChange"
          >
          </el-date-picker>
        </el-form-item>
      </template>

      <template slot="tableColumn">
        <el-table-column
            width="200"
            prop="orderId"
            :label="$t('text.orderNumber')"
            align="center"
        ></el-table-column>

        <el-table-column
            prop="status"
            :label="$t('text.creditStatus')"
            width="80"
            :formatter="$formatter.formatCreditStatus"
            align="center"
        >
          <template slot-scope="{ row }">
            <el-tag
                size="small"
                :type="row.status === '00'? 'warning': row.status === '01'? 'success': 'danger'"
            >{{
                $formatter.formatCreditStatus(null, null, row.status, null)
              }}
            </el-tag
            >
          </template>
        </el-table-column>

        <el-table-column prop="settlementStatus"
                         :formatter="$formatter.formatSettlementStatus"
                         width="100px"
                         :label="$t('text.whetherToSettle')"
                         align="center"/>

        <el-table-column
            width="180"
            prop="appId"
            :label="$t('text.appId')"
            align="center"
        ></el-table-column>
        <el-table-column
            width="120"
            prop="merchantName"
            :label="$t('text.merchantName')"
            align="center"
        ></el-table-column>

        <el-table-column
            prop="availableAmount"
            :formatter="$formatter.FenToYuanToThousandth"
            width="130px"
            :label="$t('text.creditAvailableAmount')"
            align="center"
        ></el-table-column>

        <el-table-column
            prop="grantedAmount"
            :formatter="$formatter.FenToYuanToThousandth"
            width="130px"
            :label="$t('text.creditGrantedAmount')"
            align="center"
        ></el-table-column>

        <el-table-column
            prop="amount"
            :formatter="$formatter.FenToYuanToThousandth"
            width="130px"
            :label="$t('text.creditAmount')"
            align="center"
        ></el-table-column>

        <el-table-column
            width="160"
            prop="createTimeFormat"
            :label="$t('text.creationTime')"
            align="center"
        ></el-table-column>

        <el-table-column
            width="160"
            prop="remark"
            :label="$t('text.applicationNote')"
            align="center"
        >
          <template slot-scope="{ row }">
            <div v-if="row.remark">
              <el-popover
                  v-if="row.remark.length > 10"
                  placement="top-start"
                  width="300"
                  trigger="hover"
                  :content="row.remark"
              >
                <div slot="reference" class="remark">{{ row.remark }}</div>
              </el-popover>
              <div v-else>{{ row.remark }}</div>
            </div>
            <div v-else>--</div>
          </template>
        </el-table-column>

        <el-table-column
            width="160"
            prop="dealTimeFormat"
            :label="$t('text.processingTime')"
            align="center"
        ></el-table-column>

        <el-table-column
            width="160"
            prop="approveRemark"
            :label="$t('text.approvalRemark')"
            align="center"
        >
          <template slot-scope="{ row }">
            <div v-if="row.approveRemark">
              <el-popover
                  v-if="row.approveRemark && row.approveRemark.length > 10"
                  placement="top-start"
                  width="300"
                  trigger="hover"
                  :content="row.approveRemark"
              >
                <div slot="reference" class="remark">
                  {{ row.approveRemark }}
                </div>
              </el-popover>
              <div v-else>{{ row.approveRemark }}</div>
            </div>
            <div v-else>--</div>
          </template>
        </el-table-column>
      </template>
    </page>
  </div>
</template>
<script>
import Page from "@/components/Page.vue";
import {ROLE_TYPE} from "@/utils/Constant";

export default {
  computed: {
    ROLE_TYPE() {
      return ROLE_TYPE
    }
  },
  components: {
    page: Page
  },
  props: {
    fromMerchantList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      url: "/creditApplicationRecord/selectList",
      action: "",
      timeDate: [],
      form: {
        appId: "",
        status: "",
        orderId: "",
        startDate: "",
        endDate: "",
      },
      merchantList: [],
    };
  },
  methods: {
    timeChange(e) {
      console.log(this.timeDate);
      if (e) {
        this.form.startDate = e[0];
        this.form.endDate = e[1];
      } else {
        this.form.startDate = "";
        this.form.endDate = "";
      }
    },
    reset() {
      this.timeDate = [];
    },
  },
  watch: {
    fromMerchantList() {
      this.merchantList = this.fromMerchantList;
      if (this.merchantList.length === 1) {
        this.form.appId = this.merchantList[0].value;
        this.$bus.$emit("refresh");
      }
    }
  }
};
</script>
<style scoped>

.remark {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
</style>
